import router from '@/router'; // 导入 router 实例
import store from '@/store'; // 导入 store 实例
import { getToken } from '@/utils/auth';
import cache from '@/utils/cache';
import errorCode from '@/utils/errorCode';
import { tansParams } from '@/utils/ruoyi';
import axios from 'axios';
import { Message, Notification } from 'element-ui';

// 是否显示重新登录
export let isRelogin = { show: false };

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8';

// 创建axios实例
const service = axios.create({
	baseURL: process.env.VUE_APP_BASE_API,
	timeout: 10000,
});

// request拦截器
service.interceptors.request.use(
	(config) => {
		// 是否需要设置 token
		const isToken = (config.headers || {}).isToken === false;
		// 是否需要防止数据重复提交
		const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;

		if (getToken() && !isToken) {
			config.headers['Authorization'] = 'Bearer ' + getToken();
		}

		// ========== 自动添加 orderNo 参数（修复引号问题） ==========
		const orderNo = store.state.orderNo || '';
		if (config.url !== '/open/dashboard/getOrderNoList' && config.url !== '/login' && config.url !== '/register2' && config.url !== '/open/login/sendCode' && config.url !== '/open/dashboard/forgetPassword' && config.url !== '/open/login/google') {
			// 或从 store 获取

			if (!orderNo || orderNo === 'null' || orderNo === 'undefined') {
				// ✅ 安全跳转：仅当不在 /login 时才跳转
				if (router.currentRoute.path !== '/login') {
					router.push('/login');
				}
				// 修复：这里需要返回一个 rejected promise 来阻止请求继续执行
				return Promise.reject();
			}
		}

		if (orderNo && config.method !== 'options') {
			// 确保 orderNo 是纯字符串，不带引号
			// const cleanOrderNo = String(orderNo).replace(/^"|"$/g, '');
			const cleanOrderNo = orderNo;

			// 对于 GET 请求，添加到 params
			if (config.method === 'get') {
				config.params = {
					...config.params,
					orderNo: cleanOrderNo,
				};
			}
			// 对于 POST/PUT/DELETE 请求，添加到 data
			else if (config.method === 'post' || config.method === 'put' || config.method === 'delete') {
				// 如果请求体是 FormData
				if (config.data instanceof FormData) {
					config.data.append('orderNo', cleanOrderNo);
				}
				// 如果是普通对象
				else if (config.data && typeof config.data === 'object') {
					config.data.orderNo = cleanOrderNo;
				}
				// 如果没有 data，创建一个
				else if (!config.data) {
					config.data = { orderNo: cleanOrderNo };
				}
				// 如果是字符串，尝试解析为对象
				else if (typeof config.data === 'string') {
					const dataObj = JSON.parse(config.data);
					dataObj.orderNo = cleanOrderNo;
					config.data = JSON.stringify(dataObj);
				}
			}
		}
		// ========================================

		// get请求映射params参数
		if (config.method === 'get' && config.params) {
			let url = config.url + '?' + tansParams(config.params);
			url = url.slice(0, -1);
			config.params = {};
			config.url = url;
		}

		if (!isRepeatSubmit && (config.method === 'post' || config.method === 'put')) {
			const requestObj = {
				url: config.url,
				data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
				time: new Date().getTime(),
			};
			const requestSize = Object.keys(JSON.stringify(requestObj)).length;
			const limitSize = 5 * 1024 * 1024;
			if (requestSize >= limitSize) {
				return config;
			}
			const sessionObj = cache.session.getJSON('sessionObj');
			if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
				cache.session.setJSON('sessionObj', requestObj);
			} else {
				const s_url = sessionObj.url;
				const s_data = sessionObj.data;
				const s_time = sessionObj.time;
				const interval = 1000;
				if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
					const message = '';
					return Promise.reject(new Error(message));
				} else {
					cache.session.setJSON('sessionObj', requestObj);
				}
			}
		}
		return config;
	},
	(error) => {
		Promise.reject(error);
	},
);

// 响应拦截器
service.interceptors.response.use(
	(res) => {
		const code = res.data.code || 200;
		const msg = errorCode[code] || res.data.msg || errorCode['default'];

		if (res.request.responseType === 'blob' || res.request.responseType === 'arraybuffer') {
			return res.data;
		}
		if (code === 401) {
			router.push('/login');
			return Promise.reject('');
		} else if (code === 500) {
			Message({ message: msg, type: 'error' });
			return Promise.reject(new Error(msg));
		} else if (code === 601) {
			return Promise.reject('error');
		} else if (code !== 200) {
			Notification.error({ title: msg });
			return Promise.reject('error');
		} else {
			return res;
		}
	},
	(error) => {
		let { message } = error;
		if (message == 'Network Error') {
			message = '后端接口连接异常';
		} else if (message.includes('timeout')) {
			message = '系统接口请求超时';
		} else if (message.includes('Request failed with status code')) {
			message = '系统接口' + '异常';
		}
		if (error.response && error.response.status === 401) {
			router.push('/login');
		}
		return Promise.reject(error);
	},
);

export default service;
